<template>
<svg width="20" height="22" viewBox="0 0 20 22" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M13.5 4.83436V5.33436H14H18C18.7552 5.33436 19.5 6.08424 19.5 7.16268V12.9835C19.5 13.6759 19.1651 14.2641 18.7159 14.5744L18.5 14.7235V14.9858V18.8043C18.5 19.8943 17.7652 20.6326 17 20.6326H3C2.23475 20.6326 1.5 19.8943 1.5 18.8043V14.9975V14.7326L1.2809 14.5838C0.827688 14.276 0.5 13.7031 0.5 12.9835V7.16268C0.5 6.08424 1.24475 5.33436 2 5.33436H6H6.5V4.83436V2.69131L8.22965 0.677734H11.7704L13.5 2.69131V4.83436ZM9 3.00605H8.5V3.50605V4.83436V5.33436H9H11H11.5V4.83436V3.50605V3.00605H11H9ZM11 14.6476H11.5V14.1476V11.8193V11.3193H11H9H8.5V11.8193V14.1476V14.6476H9H11Z" stroke="white"/>
</svg>
</template>

<script>
export default {}
</script>